import React from 'react'
import {Droppable} from 'react-beautiful-dnd'
import {Images} from './Images' //react-virtuoso version
//import {Images} from './Images--'
//import {Images} from './Images-' // clean but older method without react-beautiful-dnd -- Chris

export function DropTarget({project, fields, sortedImages, fullsize}) {
  return (
    <div style={{ width: '100%' }}>
      <span style={{ color: 'grey', fontSize: '12px' }}>{ sortedImages?.length && sortedImages.length > 0 ? `Total Images: ${sortedImages.length}` : '' }</span>  
      <Droppable droppableId={project.id || `pool`}>
        {(provided) => (
          <div ref={provided.innerRef} className="flex-row justify-start" style={{ maxHeight: '400px', overflowY: 'scroll' }} // Adjust the maxHeight value as needed
          {...provided.droppableProps}>
            {project.id && fields && <Images images={sortedImages} project={project} fullsize={fullsize} />}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
      {fields && fields[project.id] && fields[project.id].images && fields[project.id].images.length < 1 && (
        <div className="padding-2">This intake has no images</div>
      )}
    </div>
  )
}
